module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "shop-info",
    staticStyle: {
      "background": "#83C221"
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "font-size": ".36rem"
    }
  }, [_vm._v(_vm._s(_vm.qryProdName))])]), _vm._v(" "), _c('div', {
    staticClass: "info-bottom"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("销售额(元)")]), _vm._v(" "), _c('div', {
    staticClass: "number number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.totalSaleMoney || 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("订单量")]), _vm._v(" "), _c('div', {
    staticClass: "number number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.orderNum || 0)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-flex"
  }, [_c('div', {
    staticClass: "page-user"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.saleList), function(item, $index) {
    return _c('li', {
      key: $index,
      staticClass: "li-item"
    }, [_c('div', {
      staticClass: "table-index"
    }, [_vm._v(_vm._s(item.shopName))]), _vm._v(" "), _c('div', {
      staticClass: "table-main"
    }, [_vm._v(_vm._s(item.orderNum))]), _vm._v(" "), _c('div', {
      staticClass: "table-number"
    }, [_vm._v(_vm._s(item.totalSaleMoney))])])
  }), 0)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-table-header"
  }, [_c('div', {
    staticClass: "table-index"
  }, [_vm._v("设备名称")]), _vm._v(" "), _c('div', {
    staticClass: "table-main"
  }, [_vm._v("订单量")]), _vm._v(" "), _c('div', {
    staticClass: "table-number"
  }, [_vm._v("销售额")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6df35616","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/data/equipment/onlyProduct.vue
// module id = E8Za
// module chunks = 51